import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import backgroundImage from '../assets/background.png';
import '../css/pages_styles.css';

const Achievement = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    // 各場次的計畫資料
    const session1Data = [
        { id: 1, name: "盧達生", project: "非揮發記憶元件之計算記憶體電路模型" },
        { id: 2, name: "林敬皇", project: "工業物聯網雲系統資安測試平台之研究" },
        { id: 3, name: "陳建志", project: "多模態感知與學習架構下整合式平台與低成本智慧定位" },
        { id: 4, name: "夏世昌", project: "基於類神經網路多重物件分割之即時立體影像產生器" },
        { id: 5, name: "王志航", project: "結合社群物聯網與圖神經網路之6G元宇宙網路最佳化" },
        { id: 6, name: "廖書漢", project: "基於CPS架構的廣域物聯網森林盜伐監控與警戒系統" },
        { id: 7, name: "羅習五", project: "用於大規模多核處理器的 Linux 發行版" },
        { id: 8, name: "呂芳懌", project: "網路切片在基地台與UPF之資源配置及換手品質維護之研究" },
        { id: 9, name: "林濬璈", project: "自動機與量子演算法的自動驗證" },
        { id: 10, name: "竇其仁", project: "設計與實作一個基於交通號誌燈與車聯網之警示系統(II)" },
        { id: 11, name: "孫宏民", project: "針對以太坊智能合約的白箱模糊測試系統" },
        { id: 12, name: "徐國勛", project: "單體式應用到微服務架構的安全遷移策略與DevOps整合之研究" },
        { id: 13, name: "陳大仁", project: "狄利克雷過程改善非穩態與潛在狀態無線人體區域網路的服務品質與能源效率之研究" },
        { id: 14, name: "周承復", project: "應用深度學習去增強6G無線網路系統效能之研究" },
        { id: 15, name: "柯志亨", project: "基於流量需求的深度強化學習頻寬感知SDN路由之研究" },
        { id: 16, name: "李新林", project: "採樣策略在圖神經網路的重疊社群檢測方法之探討" },
        { id: 17, name: "趙志民", project: "在水下無線感測網路中實現具能效的來源位置隱私保護" },
        { id: 18, name: "徐逸懷", project: "6G地面衛星整合網路下基於深度強化學習之智慧頻譜共享技術研發" },
        { id: 19, name: "徐瑞壕", project: "基於後五代與六代行動網路的元宇宙架構下的智慧物聯網資安與隱私性保護技術實務之研究" },
        { id: 20, name: "蕭宏章", project: "機率記憶性應用於負載平衡" },
        { id: 21, name: "賴傳淇", project: "分散式邊緣計算結合強化學習技術之研究與探索：以無人機網路切片動態資源分配為例" },
        { id: 22, name: "孫敏德", project: "KubeGuard：容器安全智能監控與模型保護計畫" },
        { id: 23, name: "賴冠州", project: "基於雲原生之多租戶微服務資源配置/部署機制" },
        { id: 24, name: "姜美玲", project: "支援非對稱NUMA多處理器系統的作業系統核心機制的研究與實作" },
        { id: 25, name: "郭斯彥", project: "適用於異質平行運算系統與應用之高可靠度及高效能架構與機制" },
        { id: 26, name: "衛信文", project: "適用人工智慧與物聯網應用之計算型儲存系統設計" },
        { id: 27, name: "白恭瑞", project: "基於保護路由的雙重保護路由樹在網路中的實現" },
        { id: 28, name: "張庭毅", project: "區塊鏈交易之多型數位簽章智能合約部署的相關程式語言實作－以SOLANA為核心" },
        { id: 29, name: "沈上翔", project: "零信任架構中以P4交換機加速區塊鏈為基礎的身份驗證" },
        { id: 30, name: "謝瑞鴻", project: "應用於行動多核心處理器系統晶片之即時智慧型頻寬感知多功能視訊編碼設計與研究" },
        { id: 31, name: "朱鴻棋", project: "設計具公平性的壅塞控制機制" },
        { id: 32, name: "李皇辰", project: "應用物理屬性設計工業物聯網之安全機制、監控、測試平台與實地回饋框架" },
        { id: 33, name: "林子怡", project: "具資料安全性與完整性並以區塊鏈技術為基礎的智慧物聯網影像感測技術研發" },
        { id: 34, name: "張本杰", project: "適性最佳合作通訊之低軌衛星/第六代/第五代多域網路於AI車聯網研究" },
        { id: 35, name: "王士銘", project: "基於手掌影像以粒子群演算法結合獨立成分分析及內爾德-米德單體法應用於血壓之量測" },
        { id: 36, name: "焦惠津", project: "遊戲即學習：融合遊戲與程式學習的新穎體驗，開拓軟體時代的無限可能" },
        { id: 37, name: "林均翰", project: "基於使用者互動行為之行動裝置省電技術" },
        { id: 38, name: "郭大維", project: "跨越主記憶體與儲存層之高效能非揮發性記憶體儲存系統設計" },
        { id: 39, name: "林辰", project: "具有知識資訊與位元追蹤技術的RFID防碰撞協定" }
    ];

    // 第二場次的計畫資料
    const session2Data = [
        { id: 1, name: "鄭建富", project: "資料收集與邊緣計算機制於具有位置不確定性之水下無線感測網路" },
        { id: 2, name: "黃駿賢", project: "應用於農作物病蟲害程度分類與預測之可重覆使用與可適應性的邊緣人工智慧系統" },
        { id: 3, name: "曾繁勛", project: "聯邦學習之智慧邊緣邁向升級版第五代行動網路" },
        { id: 4, name: "葉羅堯", project: "建置6G韌性網路之分散式域名服務、安全路由及DPKI-based跨域網路切片認證機制" },
        { id: 5, name: "陳弘運", project: "結合人工智慧的創新性第六代無線通訊技術研究" },
        { id: 6, name: "林宗男", project: "總計畫暨子計畫一：可信任人工智慧之合規性核心技術研究" },
        { id: 7, name: "林珮瑜", project: "利用深度網路之可否認隱像術及雲端可學習加密技術" },
        { id: 8, name: "郭崇韋", project: "基於後量子密碼學控制晶片之旁通道攻擊平台建置與抗攻擊之超穎材料結構設計與分析" },
        { id: 9, name: "黃仁竑", project: "基於多資料源和深度學習的主機式入侵偵測系統" },
        { id: 10, name: "黃仁竑", project: "最佳化多階層資源卸載及人工智慧即服務模型研究" },
        { id: 11, name: "羅乃維", project: "於車聯網架構中靜態節點之安全平台設計與強固車輛身分辨識機制設計之研究" },
        { id: 12, name: "黃依賢", project: "基於SDN固定無線TDM NG-EPON和5G-Xhaul融合擷取網路之智慧綠色能源運算" },
        { id: 13, name: "石貴平", project: "以NOMA為基礎的無線供電通訊網路中藉由RIS強化以達總吞吐量最大化之研究與設計" },
        { id: 14, name: "胡誌麟", project: "分散式移動群眾感知架構下多用戶協作感測任務分配之最佳化研究" },
        { id: 15, name: "林英超", project: "基於非揮發性記憶體的容錯圖神經網路加速器" },
        { id: 16, name: "林英超", project: "以非揮發性記憶體為中心之容錯且可重組的運算架構" },
        { id: 17, name: "涂嘉恒", project: "適用於Zenoh平台的連網系統之分散式效能分析軟體" },
        { id: 18, name: "黃政嘉", project: "於車聯網架構中具匿名及延展特性下多憑證發放及驗證機制之研究" },
        { id: 19, name: "許富皓", project: "無檔案惡意程式與勒索軟體的解決方法" },
        { id: 20, name: "王丕中", project: "軟體定義網路之快速與高效節點失效保護演算法之設計與開發" },
        { id: 21, name: "鐘玉芳", project: "應用金鑰協議與霧運算安全機制於智慧醫療物聯網" },
        { id: 22, name: "陳澤雄", project: "應用安全多方計算於區塊鏈跨鏈共識機制" },
        { id: 23, name: "黃慶育", project: "具創意及人工智慧性質服務導向架構軟體之測試、除錯、安全性與可靠度評估" },
        { id: 24, name: "陳裕賢", project: "可重構智慧表面的第六代行動網路考慮空間域之節能策略" },
        { id: 25, name: "陳裕賢", project: "聯合對比式學習於人體姿態識別使用分散式毫米波雷達和相機" },
        { id: 26, name: "廖文華", project: "使用人工智慧技術於長者跌倒檢測的長期照護應用" },
        { id: 27, name: "林祝興", project: "防禦對抗式交通號誌影像辨識攻擊之演算法設計與系統開發(1/2)" },
        { id: 28, name: "陳昱圻", project: "可壓縮之驗證技術於隱私強化計算：總和驗證技術於債務證明" },
        { id: 29, name: "黃崇明", project: "在行動網路多媒體廣/羣播服務(eMBMS)環境下對於車載用戶的基於質量級式和 分層式視訊串流之無線電資源分配方法" },
        { id: 30, name: "潘孟鉉", project: "設計適用於3GPP C-V2X車聯網路自主無線資源選擇與可靠且安全訊息交換機制" },
        { id: 31, name: "嚴力行", project: "考量碳足跡與服務延遲的服務鏈嵌入" },
        { id: 32, name: "廖峻鋒", project: "適用於容器化微服務環境的非侵入式REST分散式交易機制" },
        { id: 33, name: "陳俊良", project: "子計畫三：可信任人工智慧系統強韌性與公平性技術研發與整合應用" },
        { id: 34, name: "陳宜惠", project: "基於深度學習技術之媒體隱私保護機制" },
        { id: 35, name: "楊明豪", project: "次世代基因定序交易與管理方法" },
        { id: 36, name: "王世仁", project: "實證研究CAFC之適格性判決以協助我國軟體產業之發展" },
        { id: 37, name: "楊武", project: "基於多面體編譯器技術的GPU程式優化研究" },
        { id: 38, name: "陳懷恩", project: "確定性6G行動網路之邊緣運算與超可靠低延遲研究" },
        { id: 39, name: "蔡欣穆", project: "次世代車輛無線光通訊及定位系統" }
    ];

    // 第三場次的計畫資料
    const session3Data = [
        { id: 1, name: "葉國暉", project: "跨區塊鏈之物聯網信任架構" },
        { id: 2, name: "周立德", project: "基於AI之5G/B5G網路切片管理與安全技術之研究" },
        { id: 3, name: "朱正忠", project: "軟體工程(SE)與人工通用智慧(AGI)之協調合作研究(1/3)" },
        { id: 4, name: "BaghbanHojjat", project: "多域邊緣智慧生態系中可靠的服務鏈編排：彌合無縫服務管理的邊界" },
        { id: 5, name: "黃柏鈞", project: "次世代記憶儲存系統之機器學習與資料探勘演算法設計與最佳化" },
        { id: 6, name: "陳碩漢", project: "基於新興記憶-儲存架構之資料安全抹除與安全威脅防範設計" },
        { id: 7, name: "蘇淑茵", project: "透過轉移學習實現適應動態環境變化的智慧型無線室內定位系統" },
        { id: 8, name: "王建民", project: "基於自適應性之多任務理論與演算法的元增強學習研究與應用平台" },
        { id: 9, name: "陳錫民", project: "以同儕審查為基礎的學生軟體專案之貢獻分析洞察系統" },
        { id: 10, name: "孫雅麗", project: "基於AI的自動化APT惡意軟體之威脅情資報告生成" },
        { id: 11, name: "吳晉賢", project: "基於快閃記憶體存取的固態硬碟之關鍵改善技術" },
        { id: 12, name: "林風", project: "基於强化學習的次世代網路(NGN)之資源管理" },
        { id: 13, name: "賴裕昆", project: "子計畫三：於P4軟體定義網路架構可程式化交換器之高速流量資訊熵估算設計與研究" },
        { id: 14, name: "葉春超", project: "具有拜占庭穩健性的聯邦式學習機制設計" },
        { id: 15, name: "劉德隆", project: "子計畫一：P4軟體定義網路架構之對稱式智慧繞徑設計與研究" },
        { id: 16, name: "洪鼎詠", project: "模型壓縮的軟硬體協同設計" },
        { id: 17, name: "李揚漢", project: "人工智慧禽畜物聯網屠宰衛生檢查系統之研究開發" },
        { id: 18, name: "陳增益", project: "於斯格明子為基礎之計算架構上啟用機器學習演算法:概念，挑戰，與 設計" },
        { id: 19, name: "石維寬", project: "次世代混合式記憶體之高效能鍵/值管理方案設計" },
        { id: 20, name: "黃元欣", project: "建構自動產生支援RISC-V客製化指令的協處理器與編譯器的開發環境" },
        { id: 21, name: "梁郁珮", project: "交錯式磁紀錄硬碟之高效管理策略" },
        { id: 22, name: "梁郁珮", project: "針對異質多核心處理器架構之基於機器學習的效能及耗能預測模型" },
        { id: 23, name: "范姜永益", project: "應用OpenAPI與同步通訊架構整合微服務與物聯網之研究" },
        { id: 24, name: "劉建宏", project: "使用好奇心驅動爬行與強化學習方法於Android應用程式探索與測試" },
        { id: 25, name: "林柏青", project: "在非地面網路中邊緣運算和實體層的安全與隱私機制" },
        { id: 26, name: "李宗翰", project: "以聯邦遷移學習與生成對抗網路強化5G網路切片之異質網路入侵偵測" },
        { id: 27, name: "查士朝", project: "車聯網異質服務之風險導向存取控制與隱私保護" },
        { id: 28, name: "許揚", project: "服務運算下自動化技術之開發與研究：服務描述元素的辨別及擷取與服務品質的塑模和預測" },
        { id: 29, name: "郭建志", project: "結合行動邊緣運算與社群物聯網之聯合式學習抵禦攻擊機制" },
        { id: 30, name: "楊昌彪", project: "最長遞增數值區間子序列及其相關問題" },
        { id: 31, name: "胡偉文", project: "基於非對稱剪裁直流偏壓正交分頻多工之水下可見光通訊網路設計與開發" },
        { id: 32, name: "吳宗成", project: "基於模糊測試之無線穿戴裝置資安弱點檢測技術研發" },
        { id: 33, name: "莊永裕", project: "生成式AI輔助程式設計之程式語言支援與函式庫框架研發" },
        { id: 34, name: "林俊淵", project: "建置基於顯微鏡圖像之細胞-粒子相互作用分析平臺" },
        { id: 35, name: "林清池", project: "圓形圖上「完全支配點問題」與「成對支配點問題」的近似演算法設計" },
        { id: 36, name: "王柏堯", project: "安全RISC-V後量子密碼程式" },
        { id: 37, name: "林其誼", project: "大型停車場之專屬停車引導服務應用研究與實作(II)" },
        { id: 38, name: "吳沛遠", project: "子計畫二：可信任人工智慧系統之多方安全計算隱私強化深度學習" },
        { id: 39, name: "巫芳璟", project: "基於與機器人互動之跨域資料標註技術" }
    ];

    // 第四場次的計畫資料
    const session4Data = [
        { id: 1, name: "陳文村", project: "考慮社群物聯網與數位雙生之具有邊緣人工智慧之B5G/6G網路研究" },
        { id: 2, name: "李文廷", project: "具有負載平衡機制的微服務閘道框架之研究" },
        { id: 3, name: "蔡孟宗", project: "基礎圖論與幾何問題的串流資料演算法 (IV)" },
        { id: 4, name: "李政崑", project: "總計畫暨子計畫一:支援RISC-V異質多核心系統的編譯器最佳化" },
        { id: 5, name: "黃文祥", project: "在5G異質結構變動下具加強型深度學習KD-WMN的自我配置之研究(2/3)" },
        { id: 6, name: "謝仁偉", project: "高效能疊瓦式硬碟/交錯式硬碟儲存系統設計" },
        { id: 7, name: "黃意婷", project: "開發永續性 Windows 惡意程式行為偵測：行為混淆攻擊與模型韌性加強" },
        { id: 8, name: "黃能富", project: "高效率AIoT智慧農業數位分身模型雲端服務平台之研製" },
        { id: 9, name: "許慶賢", project: "基於軟體定義網路的邊-雲大規模計算遷移策略研究" },
        { id: 10, name: "周兆龍", project: "基於集成學習與融合生物行為特徵之零信任架構持續性認證技術" },
        { id: 11, name: "范俊逸", project: "具多關鍵字搜尋之抗量子多中心屬性代理轉加密郵件系統" },
        { id: 12, name: "林致宇", project: "聯邦式學習應用於多模態車輛協同感知" },
        { id: 13, name: "吳晉賢", project: "針對疊瓦式硬碟的存取公平性、閒置時間利用及高效能空間配置之系統設計" },
        { id: 14, name: "林盈達", project: "多代理強化學習的卸載於5G核網、邊緣雲、車聯網和車聯霧" },
        { id: 15, name: "張經略", project: "賦距空間的最大生成樹之次線性計算" },
        { id: 16, name: "曾一凡", project: "適用於區塊鏈之後量子帳戶安全機制研究與開發" },
        { id: 17, name: "陳延華", project: "使用理徳索羅門碼的公鑰密碼系統於後量子密碼之研究" },
        { id: 18, name: "李信杰", project: "文字重疊與低對比度偵測於網頁視覺測試之研究" },
        { id: 19, name: "李南逸", project: "可抗量子電腦攻擊之群組型認證金鑰交換協議" },
        { id: 20, name: "簡宏宇", project: "整合以切片為基礎的代理認證及階層式代理認證以改善 5G-IoT認證挑戰" },
        { id: 21, name: "朱宗賢", project: "基於穿戴式攝影機之老人跌倒預防、偵測與救援系統" },
        { id: 22, name: "張鈞淯", project: "基於物聯網系統與低碳排之Green AI模型開發於智慧茶園應用" },
        { id: 23, name: "陳增益", project: "於混合式記憶儲存平台上高效能資料索引系統設計以支援機器學習應用" },
        { id: 24, name: "石維寬", project: "利用較低層次儲存的內容作為提示以提升多層次儲存系統中的資料重複刪除效能" },
        { id: 25, name: "彭勝龍", project: "平衡生成林問題之研究" },
        { id: 26, name: "楊進雄", project: "分層立方體網路的鄰居連通度研究" },
        { id: 27, name: "張肇明", project: "資料中心網路在擬陣連通度上之鏈結/交換器故障分析" },
        { id: 28, name: "羅嘉寧", project: "容器服務之跨節點逃逸攻擊及其防禦" },
        { id: 29, name: "范倫達", project: "高精準度暨低運算量犯罪偵測設計" },
        { id: 30, name: "高信雄", project: "以人工智慧(AI)驅動之整合性區塊鏈犯罪偵防研究" },
        { id: 31, name: "賴源正", project: "於階層網路中聯盟式學習之效能最佳化" },
        { id: 32, name: "龔自良", project: "基於叢集切割之網路脆弱性分析及元件叢集連通度之計算(2)" },
        { id: 33, name: "楊慶隆", project: "植基於改錯碼具有評估和克服參與者不誠實的秘密影像分享機制" },
        { id: 34, name: "陳宗禧", project: "在物聯網環境下行人智慧辨識與移動軌跡預測之研究" },
        { id: 35, name: "滕元翔", project: "圖形的條件連通性與結構連通性" },
        { id: 36, name: "張軒彬", project: "設計與實作一個基於機器學習的跨階層異質性儲存系統之預讀框架" },
        { id: 37, name: "張哲維", project: "記憶體與儲存裝置融合系統之效能調校與省電設計" },
        { id: 38, name: "林政翰", project: "軟體定義網路使用模糊邏輯理論設計路由路徑之研究" },
        { id: 39, name: "莊清智", project: "基於工業物聯網之混合式網路架構優化" }
    ];

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                        className="header"
                        style={{backgroundImage: `url(${backgroundImage})`}}
                        >
                        <h1 className="title">國科會研究成果發表</h1>
                    </header>

                    {/* 第一場次 */}
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 國科會研究成果發表 I (洛克廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：10:00-10:50 | 日期：2025/08/25
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '80px' }}>海報號碼</th>
                                        <th className="th" style={{ width: '120px' }}>主持人姓名</th>
                                        <th className="th">計畫名稱</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session1Data.map((item, index) => (
                                        <tr key={item.id}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                {item.id}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center' }}>
                                                {item.name}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.project}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    {/* 第二場次 */}
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 國科會研究成果發表 II (洛克廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：15:20-16:10 | 日期：2025/08/25
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '80px' }}>海報號碼</th>
                                        <th className="th" style={{ width: '120px' }}>主持人姓名</th>
                                        <th className="th">計畫名稱</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session2Data.map((item, index) => (
                                        <tr key={item.id}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                {item.id}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center' }}>
                                                {item.name}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.project}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 國科會研究成果發表 III (洛克廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：09:30-10:20 | 日期：2025/08/26
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '80px' }}>海報號碼</th>
                                        <th className="th" style={{ width: '120px' }}>主持人姓名</th>
                                        <th className="th">計畫名稱</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session3Data.map((item, index) => (
                                        <tr key={item.id}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                {item.id}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center' }}>
                                                {item.name}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.project}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 國科會研究成果發表 IV (洛克廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：10:30-11:20 | 日期：2025/08/26
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '80px' }}>海報號碼</th>
                                        <th className="th" style={{ width: '120px' }}>主持人姓名</th>
                                        <th className="th">計畫名稱</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session4Data.map((item, index) => (
                                        <tr key={item.id}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                {item.id}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center' }}>
                                                {item.name}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.project}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default Achievement;